import { BUTTON_NAMES, FIELDS_LABEL, INPUT_KEYS, IS_BUY, IS_CALL } from "constants/addOption";
import { formatNumber } from "../generalHelper";


export const findGCD = (input,d) => {
  if (toString.call(input) !== "[object Array]")  
      return  false;  
  var len, a, b; 
len = input.length;
if ( !len ) {
  return null;
}
a = input[ 0 ];
for ( var i = 1; i < len; i++ ) {
  b = input[ i ];
  a = gcd_two_numbers( a, b );
}
return a;
}

function gcd_two_numbers(x, y) {
  if ((typeof x !== 'number') || (typeof y !== 'number')) 
    return false;
  x = Math.abs(x);
  y = Math.abs(y);
  while(y) {
    var t = y;
    y = x % y;
    x = t;
  }
  return x;
}


export const reformatSubmitData = (data) =>{
  const concatRatiosWithStrikes = Object.keys(data['strikeValues']).map((item, index) => {
    const strikeValue = data['strikeValues'][item];
    const ratioValues = data['ratioValues'][item];
    return {
      strike:strikeValue.value,
      ratio : ratioValues.value,
      buy: ratioValues[INPUT_KEYS.BUTTON] === BUTTON_NAMES.BUY ? ratioValues[IS_BUY] = 1 : ratioValues[IS_BUY] = 0,
      call: strikeValue[INPUT_KEYS.BUTTON] === BUTTON_NAMES.CALL ? strikeValue[IS_CALL] = 1 : strikeValue[IS_CALL] = 0
    }
  });
  let bespokeCheck= JSON.parse(JSON.stringify(data.checkedBespoke)) 
  
  // Check if the commodity/shortcut is CSO
  const isCSO = data[FIELDS_LABEL.COMMODITY.key]?.label?.toLowerCase().includes("cso") || false;

  const buildBespokeTenorPayload = (tenorData) => ({
    style_period_tenor_id: "Bespoke",
    period_id: data.bespokePeriodId ?? 1,
    bespoke_tenor_selections: (Array.isArray(tenorData) ? tenorData : []).filter(
      (item) => item != null
    ),
  });

  let tenors_data=[]
   if (Object.keys(bespokeCheck).length) {
     Object.keys(bespokeCheck).forEach((bespokeKey)=>{
      let check=bespokeCheck[bespokeKey]?1:0
      const tenorData = data[FIELDS_LABEL.TENOR.key][bespokeKey];
      const isTenorArray = Array.isArray(tenorData);
      
      if(check){
        tenors_data.push(buildBespokeTenorPayload(tenorData))
      }
      else if(isTenorArray && tenorData.length > 0){
        // CSO: Multiple tenors selected (array format, but is_bespoke = 0)
        let csoData= {
          is_bespoke:check,
          style_period_tenor_id: isCSO ? null : tenorData[0], // null for CSO, otherwise use first tenor
          style_period_tenor_months:tenorData.map((tenorId)=>{
            return {
              style_period_tenor_month_id: tenorId
            }
          }),
        }
        tenors_data.push(csoData)
      }
      else{
        tenors_data.push({ style_period_tenor_id: tenorData })
      }
    })
   }
  
  
  
  

  data = {
    ...data,
    tenors: tenors_data,
    product_contract_style_id: data[FIELDS_LABEL.COMMODITY.key]?.value,
    // contract_style : data[FIELDS_LABEL.CONTRACT_STYLE.key],
    option_type_id : data[FIELDS_LABEL.TYPE.key],
    cost_of_carry : data[FIELDS_LABEL.COST_OF_CARRY.key],
    underlyings: Object.values(data['underlyingData']).map(item => ({value: item})),
    [FIELDS_LABEL.AVERAGES.key] :  data[FIELDS_LABEL.AVERAGES.key],
    num_legs : data[FIELDS_LABEL.LEGS.key],
    legs : concatRatiosWithStrikes // ratios and strikes
  };

  delete data.checkedBespoke;
  delete data.contractStyle;
  delete data.costOfCarry;
  delete data.ratioValues;
  delete data.strikeValues;
  delete data.underlyingData;
  delete data.commodity;
  delete data.bespokePeriodId;
  
  return data;
};


export const formatUnit = (value,params) => {
  if(value === '' || !value) return value;
  let formattedValue = value;
  const field = params.colDef.field;
  const data = params.node.group ? params.node.aggData : params.node.data;
  let transfomedFieldKey = field.replace('bid','premium').replace('ask','premium').replace('company','premium');
  const unitKey = transfomedFieldKey + '_unit';

  const unit = data[unitKey];
  if(unit !== undefined &&  unit !== '') formattedValue = formatNumber(value) + unit;
  
  return formattedValue;
};

 
export const isSublegRow = (node) => {
  if(node.level === 2) return true;
  const rowData = node.group ? node.aggData : node.data;
  const isSubleg = (node.level === 1 && rowData.level_one_row_type === 'subleg');
  return isSubleg;
}